import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;
